var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "portables" }, [
    _c("table", { staticClass: "w-full" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.stats, function(item, index) {
          return _c("tr", { key: index, staticClass: "bg-light-grey" }, [
            _c("td", {
              staticClass: "border divide-primary p-2",
              domProps: { innerHTML: _vm._s(item.title) }
            }),
            _vm._v(" "),
            _c("td", {
              staticClass: "border divide-primary p-2 align-top text-center",
              domProps: { innerHTML: _vm._s(item.qty) }
            }),
            _vm._v(" "),
            _c("td", {
              staticClass: "border divide-primary p-2 align-top text-center",
              domProps: { innerHTML: _vm._s(_vm.equivalized(item)) }
            })
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("tfoot", [
        _c("tr", { staticClass: "text-xl text-green font-bold bg-primary" }, [
          _c("td", { staticClass: "p-2 uppercase" }, [_vm._v("Grand Total")]),
          _vm._v(" "),
          _c("td", {
            staticClass: "p-2 align-top text-center",
            domProps: { innerHTML: _vm._s(_vm.totalQty) }
          }),
          _vm._v(" "),
          _c("td", {
            staticClass: "p-2 align-top text-center",
            domProps: { innerHTML: _vm._s(_vm.totalEquivalized) }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", { staticClass: "text-xl text-green font-bold bg-primary" }, [
        _c("td", { staticClass: "p-2" }, [_vm._v("Product Name")]),
        _vm._v(" "),
        _c("td", { staticClass: "p-2 text-center" }, [_vm._v("Qty.")]),
        _vm._v(" "),
        _c("td", { staticClass: "p-2 text-center" }, [
          _vm._v("Equivalized Qty.")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }